import dayjs from 'dayjs';

import type {CourseApiModel} from '../../../api/course';
import type {Nullable} from '../../utility-types';

import {REQUEST_REFUND_EXPIRED_DAYS} from '../../../modules/payments/utils';
import {datetimeObjToISOString} from '../../datetime';

export const isCourseRequestRefundExpired = (
  course?: Nullable<CourseApiModel>,
) => {
  if (!course?.end_date) {
    return true;
  }

  const courseEndDate = dayjs(datetimeObjToISOString(course.end_date));

  return dayjs().diff(courseEndDate, 'day') > REQUEST_REFUND_EXPIRED_DAYS;
};
